import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TPostManualUploadI9DocumentRequest,
  TPostManualUploadI9DocumentResponse,
} from "./postManualUploadI9DocumentSchema";

export const postManualUploadI9Document = (axios: IAxiosInstance) => {
  return async (params: TPostManualUploadI9DocumentRequest) => {
    const formData = new FormData();
    formData.append("employeeID", params.employeeID);
    formData.append("companyID", params.companyID);
    formData.append("document_type", params.document_type);

    if (params.files) {
      if (params.files instanceof FileList) {
        Array.from(params.files).forEach((file) => {
          formData.append("files", file);
        });
      } else if (Array.isArray(params.files)) {
        params.files.forEach((file) => {
          formData.append("files", file);
        });
      }
    }

    const response =
      await axios.noRetry.post<TPostManualUploadI9DocumentResponse>(
        "/api/internal/i9-documents/manual-upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    return response.data;
  };
};
